import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { detectMobilePlatform, isMobileDevice, MobilePlatform } from '../../core/device.utils';
import { AppStoreLink, TenantAppDownloadConfig } from '../../core/site-config.model';

type StorePlatform = 'ios' | 'android';

@Component({
  selector: 'app-app-download',
  imports: [ButtonModule, DialogModule],
  templateUrl: './app-download.component.html',
  styleUrl: './app-download.component.scss',
})
export class AppDownloadComponent implements OnInit {
  @Input({ required: true }) config!: TenantAppDownloadConfig;
  @Input() compact = false;

  public isMobile = false;
  public platform: MobilePlatform = 'desktop';
  public qrModalVisible = false;
  public qrModalStore: StorePlatform | null = null;

  ngOnInit(): void {
    this.isMobile = isMobileDevice();
    this.platform = detectMobilePlatform();
  }

  public isPrimaryStore(store: StorePlatform): boolean {
    if (this.platform === 'ios') {
      return store === 'ios';
    }
    if (this.platform === 'android') {
      return store === 'android';
    }
    return false;
  }

  public get qrModalTitle(): string {
    if (!this.qrModalStore) {
      return 'Descargar app';
    }

    return `Descargar en ${this.getStoreConfig(this.qrModalStore).buttonLabel}`;
  }

  public get activeQrImageUrl(): string | undefined {
    if (!this.qrModalStore) {
      return undefined;
    }

    return this.getStoreConfig(this.qrModalStore).qrImageUrl;
  }

  public get activeStoreUrl(): string | undefined {
    if (!this.qrModalStore) {
      return undefined;
    }

    return this.getStoreConfig(this.qrModalStore).storeUrl;
  }

  public onStoreAction(store: StorePlatform, event: Event): void {
    if (this.isMobile) {
      return;
    }

    event.preventDefault();
    this.qrModalStore = store;
    this.qrModalVisible = true;
  }

  public openStoreInBrowser(): void {
    const url = this.activeStoreUrl;
    if (!url) {
      return;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
  }

  private getStoreConfig(store: StorePlatform): AppStoreLink {
    return store === 'ios' ? this.config.ios : this.config.android;
  }
}
